module.exports = __webpack_public_path__ + "img/worldwide-belongings.c40865ef.png";